/**
 * Le rond « ⬆ » en bas à droite d'un écran plein : un toucher remonte tout en
 * haut d'un long catalogue, où sont le retour et les envois.
 *
 * @param {object} props propriétés
 * @param {{current: HTMLElement|null}} props.cible l'élément qui défile
 * @returns {import('react').ReactElement} le bouton
 */
export function BoutonHaut({ cible }) {
  return (
    <button
      type="button"
      className="cat-noprint"
      aria-label="⬆"
      onClick={() => cible.current?.scrollTo({ top: 0, behavior: 'smooth' })}
      style={{
        position: 'fixed',
        right: 16,
        bottom: 'calc(18px + env(safe-area-inset-bottom, 0px))',
        zIndex: 3,
        // Plus petit, il cache moins les prix qui défilent dessous.
        width: 44,
        height: 44,
        borderRadius: 22,
        border: 'none',
        background: '#0F1A2E',
        color: '#fff',
        fontSize: 19,
        fontWeight: 800,
        boxShadow: '0 6px 18px rgba(15,26,46,.35)',
        cursor: 'pointer',
      }}
    >
      ⬆
    </button>
  );
}
